import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type {
  DashboardLatestTransaction,
  DashboardStockHighlights,
  DashboardSummary,
} from '../types/dashboard.types';

export const fetchDashboardSummary = async (): Promise<DashboardSummary> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.dashboardSummary}`);
};

/** null while there is no order */
export const fetchLatestTransaction = async (): Promise<DashboardLatestTransaction | null> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.dashboardLatestTransaction}`);
};

/** `limit` rows per list (1-50, default 10); low stock is 1..`threshold` available (default 5). */
export const fetchStockHighlights = async (
  limit?: number,
  threshold?: number
): Promise<DashboardStockHighlights> => {
  const params = new URLSearchParams();
  if (limit !== undefined) params.set('limit', String(limit));
  if (threshold !== undefined) params.set('threshold', String(threshold));
  return await request.get(`${URLS.BACK_DSH}${APIS.dashboardStockHighlights(params.toString())}`);
};
